export default "__VITE_ASSET__91e1d2cc__"